"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nonThemeableRules = exports["default"] = void 0;
// Setting up nonThemeableRules for use within the React component generator
var nonThemeableRules = {
  packageName: 'SourceTobiIcons',
  defaultSize: 3,
  hasNumberBadge: false,
  size: {
    1: {
      sm: 16,
      md: 16,
      lg: 16,
      xl: 16
    },
    2: {
      sm: 20,
      md: 20,
      lg: 20,
      xl: 20
    },
    3: {
      sm: 20,
      md: 24,
      lg: 24,
      xl: 24
    },
    4: {
      sm: 24,
      md: 32,
      lg: 32,
      xl: 32
    },
    5: {
      sm: 32,
      md: 36,
      lg: 36,
      xl: 36
    },
    6: {
      sm: 36,
      md: 40,
      lg: 40,
      xl: 40
    },
    7: {
      sm: 40,
      md: 48,
      lg: 48,
      xl: 48
    },
    8: {
      sm: 48,
      md: 56,
      lg: 56,
      xl: 56
    },
    9: {
      sm: 56,
      md: 64,
      lg: 64,
      xl: 64
    },
    10: {
      sm: 64,
      md: 72,
      lg: 72,
      xl: 72
    },
    11: {
      sm: 72,
      md: 84,
      lg: 84,
      xl: 84
    },
    12: {
      sm: 84,
      md: 96,
      lg: 96,
      xl: 96
    },
    13: {
      sm: 96,
      md: 120,
      lg: 120,
      xl: 120
    },
    14: {
      sm: 120,
      md: 192,
      lg: 192,
      xl: 192
    }
  }
};
exports.nonThemeableRules = nonThemeableRules;

var ruleSet = function ruleSet() {
  return nonThemeableRules;
};

var _default = ruleSet;
exports["default"] = _default;
//# sourceMappingURL=ruleSet.js.map